import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const ehMadsen = require("../images/EHMadsen_portrait_web.jpg");
const diane = require("../images/diane.jpg");
const julie = require("../images/julie.jpg");
const kristen = require("../images/kristen.jpg");
const marie = require("../images/marie.jpg")

export const About = () => {
  return (
    <Container fluid className="content">
      <Row>
        <Col className="title">
          <h1>About Us</h1>
        </Col>
      </Row>
      <Row className="frame-row">
        <Col sm={3} md={2} lg={2}>
          {" "}
        </Col>
        <Col sm={6} md={4} lg={3} className="image-column">
          <img src={ehMadsen} alt="Dr. Madsen Portrait" />
        </Col>
        <Col sm={6} md={4} lg={5}>
          <p>
            Dr. Madsen received his Dental degree from the University of
            Washington, and his degree as an Orthodontic Specialist from Loma
            Linda University. He has extensive post doctoral education and
            experience in treating normal an unusual conditions.
          </p>
          <p>
            He was a founding member of the Pediatric Dental Residency Program
            at Primary Children's Medical Center (PCMC). He was the Orthodontic
            Director there for over a decade. He was also a founding member of
            the Craniofacial Panel at PCMC.
          </p>
          <p>
            Most of our team has been working together for many years. We love
            what we do and find great satisfaction in knowing our patient's
            needs and taking great care of them.
          </p>
        </Col>
        <Col sm={3} md={2} lg={2}>
          {" "}
        </Col>
      </Row>

      <Row>
        <Container fluid className="alternate">
          <Row>
            <Col className="topicHeader">
              <h2>
                Our wonderful staff is devoted to helping you find your
                beautiful smile!
              </h2>
            </Col>
          </Row>
          <Row>
            <Col sm={6} med={3} lg={3} className="staff">
              <img src={diane} alt="Dr Madsen's Staff" />
            </Col>
            <Col sm={6} med={3} lg={3} className="staff">
              <img src={julie} alt="Dr Madsen's Staff" />
            </Col>
            <Col sm={6} med={3} lg={3} className="staff">
              <img src={kristen} alt="Dr Madsen's Staff" />
            </Col>
            <Col sm={6} med={3} lg={3} className="staff">
              <img src={marie} alt="Dr Madsen's Staff" />
            </Col>
          </Row>
        </Container>
      </Row>
    </Container>
  );
};
